import stringify from './stringify';
import parse from './parse';

export default {
  stringify,
  parse,
}
